import { Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

export default function ResidentialService() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'Ménage à Domicile',
      description: 'Service de ménage complet adapté à vos besoins spécifiques',
      price: 'À partir de 25€/h',
      features: [
        'Aspirateur et serpillère de tous les sols',
        'Dépoussiérage complet des meubles',
        'Nettoyage approfondi des sanitaires',
        'Cuisine : plan de travail, évier, plaques',
        'Chambres : rangement et nettoyage',
        'Salon : aspiration canapés et coussins'
      ]
    },
    {
      icon: 'ri-window-line',
      title: 'Lavage de Vitres',
      description: 'Vitres impeccables pour une luminosité optimale',
      price: 'À partir de 15€/fenêtre',
      features: [
        'Matériel professionnel haute qualité',
        'Nettoyage sans traces garanti',
        'Encadrements et rebords inclus',
        'Intervention régulière ou ponctuelle',
        'Vitres intérieures et extérieures',
        'Devis gratuit sur place'
      ]
    },
    {
      icon: 'ri-broom-line',
      title: 'Nettoyage Profond',
      description: 'Grand ménage pour occasions spéciales',
      price: 'Sur devis',
      features: [
        'Ménage de déménagement complet',
        'Nettoyage de fin de bail certifié',
        'Remise en état après travaux',
        'Grand ménage de printemps',
        'Nettoyage de cave et grenier',
        'Garantie satisfaction'
      ]
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/30">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(59, 130, 246, 0.8), rgba(37, 99, 235, 0.8)), url('https://readdy.ai/api/search-image?query=Professional%20residential%20house%20cleaning%20service%20team%20working%20in%20modern%20bright%20home%20interior%20with%20cleaning%20equipment%20and%20supplies%2C%20natural%20lighting%2C%20clean%20minimalist%20background%2C%20high%20quality%20photography%2C%20sparkling%20clean%20surfaces%2C%20professional%20atmosphere%2C%20blue%20and%20white%20color%20scheme&width=1920&height=800&seq=residential-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-6">
            <Link to="/" className="inline-flex items-center text-blue-200 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-left-line mr-2"></i>
              Retour à l'accueil
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Entretien Résidentiel
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
            Un service de ménage personnalisé pour votre confort au quotidien
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calculator-line mr-2"></i>
              Devis Gratuit
            </button>
            <button
              onClick={() => window.location.href = 'tel:+14384081200'}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              438 408 1200
            </button>
          </div>
        </div>
      </section>

      {/* Services détaillés */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nos Services Résidentiels
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Des solutions adaptées à chaque besoin pour maintenir votre domicile impeccable
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
                <div 
                  className="h-48 bg-cover bg-center relative"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20residential%20cleaning%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20in%20modern%20home%20interior%20with%20cleaning%20equipment%2C%20bright%20clean%20environment%2C%20blue%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20sparkling%20clean%20surfaces%2C%20professional%20atmosphere&width=600&height=400&seq=residential-detail-${index}&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-blue-600/20"></div>
                  <div className="absolute top-4 left-4 w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                    <span className="text-lg font-semibold text-blue-600">{service.price}</span>
                  </div>
                  
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-check-line text-green-500 mr-3 mt-1"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button
                    onClick={scrollToContact}
                    className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Réserver ce service
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Pourquoi Choisir Notre Service ?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Personnel Qualifié</h3>
              <p className="text-gray-600">Équipe formée, assurée et de confiance</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-leaf-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Produits Écologiques</h3>
              <p className="text-gray-600">Solutions respectueuses de l'environnement</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-semibold mb-3">Horaires Flexibles</h3>
              <p className="text-gray-600">Intervention selon votre planning</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}